interface GiftCardProps {
    active: boolean;
    maxLength: number;
    message: string;
}

type UpsellCategory = {
    id: number;
    priority: number;
};

type UpsellProduct = {
    amountInCart: number;
    amountMutable: boolean;
    cartItemId: number;
    editHash: string | null;
    extraInformation: string;
    id: number;
    imgUrl: string;
    inCart: boolean;
    isHappyArProduct: boolean;
    locked: boolean;
    name: string;
    personalized: boolean;
    previewImage: string | null;
    price: {
        numericValue: number;
        value: string;
    };
    uniqueId: string | null;
};

type AvailableUpsellGroups = Record<string, UpsellGroupProps[]>;

type UpsellGroupProps = {
    category: UpsellCategory;
    id: number;
    products: UpsellProduct[];
};

interface UpsellState {
    editorFontCacheVersion: string | null;
    groups: AvailableUpsellGroups;
}

const initialUpsellState: UpsellState = {
    editorFontCacheVersion: null,
    groups: {},
};

export type { UpsellState, GiftCardProps, UpsellGroupProps, UpsellProduct, AvailableUpsellGroups };
export default initialUpsellState;
